import { CssType, ThemeType } from '@theming/jssTypes';

const styles = (theme: ThemeType): CssType => ({
  pageContainer: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.color.semantic.background.neutral.primary,
    padding: theme.spacing[4],
  },
  card: {
    width: '100%',
    maxWidth: '480px',
    backgroundColor: theme.color.semantic.background.neutral.secondary,
    borderRadius: theme.radius.md,
    boxShadow: theme.shadow.md,
    padding: theme.spacing[6],
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing[4],
  },
  title: {
    fontSize: theme.typography.fontSize.xl,
    fontWeight: theme.typography.fontWeight.semibold,
    color: theme.color.semantic.text.primary,
    margin: theme.spacing[0],
  },
  subtitle: {
    fontSize: theme.typography.fontSize.md,
    color: theme.color.semantic.text.tertiary,
    margin: theme.spacing[0],
  },
  detailRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing[1],
  },
  detailLabel: {
    fontSize: theme.typography.fontSize.sm,
    color: theme.color.semantic.text.tertiary,
    fontWeight: theme.typography.fontWeight.medium,
  },
  detailValue: {
    fontSize: theme.typography.fontSize.md,
    color: theme.color.semantic.text.primary,
    wordBreak: 'break-all',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing[3],
    marginTop: theme.spacing[2],
  },
  errorMessage: {
    fontSize: theme.typography.fontSize.sm,
    color: theme.color.semantic.brand.danger.primary,
    margin: theme.spacing[0],
  },
  emptyStateMessage: {
    fontSize: theme.typography.fontSize.md,
    color: theme.color.semantic.text.secondary,
    textAlign: 'center',
    margin: theme.spacing[0],
  },
});

export default styles;
